<img src="assets/fake_carousels.png" />

<div class="dialog-container">
  <opac-confirmation-dialog
    [acceptLabel]="'common.accept'"
    [cancelLabel]="undefined"
    [open]="showConfirmationEmailDialog()"
    [title]="'login.validated.user' | translate"
    (accept)="closeConfirmationEmailDialog()"
    (cancel)="closeConfirmationEmailDialog()">
    <p>{{ confirmationEmailLabel() | translate }}</p>
  </opac-confirmation-dialog>
  <opac-reset-password-dialog #resetPasswordDialog (submit)="handleResetPasswordDialog()"></opac-reset-password-dialog>
</div>
